import axios from "axios";
import {
    GET_ERRORS,
    USER_ADD,
    USER_UPDATE
} from "./types";
import * as myConstList from "./baseUrl"

const baseUrl = myConstList.baseUrl;

export const addPair = (pairData, history) => dispatch => {
    axios
        .post(baseUrl + "/api/v1/addpair", pairData)
        .then(res =>
            dispatch({
                type: "PAIR_ADD",
                payload: res,
            })
        ).catch(err =>
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    );
};


export const updatePair = (pairData) => dispatch => {
    axios
        .put(baseUrl + "/api/v1/updatepairs", pairData)
        .then(res =>
            dispatch({
                type: "PAIR_UPDATE",
                payload: res,
            })
        ).catch(err =>
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        })
    );
};
